module.exports = __webpack_public_path__ + "assets/icons/parameters-logo.135d233c4798141d796bfaaee74f6eac.svg";